import styled, {keyframes} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Link} from 'components/ui-kit/Link';
import {breakpoint, colors, font} from 'theme';

export const ColumnsWrapper = styled.div`
    display: flex;
    gap: 40px;
    max-width: 900px;

    @media (min-width: ${breakpoint.phone}) {
        margin-bottom: 40px;
    }
`;

export const Column = styled.div`
    margin-bottom: 16px;
    flex: 1;
`;

export const Typography = styled.div`
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1px;
    word-wrap: break-word;
`;

export const HeaderTypography = styled(Typography)`
    font-size: 13px;
    line-height: 14px;
    color: ${colors.textSecondary};
    margin-bottom: 6px;
`;

export const CustomLink = styled(Link)`
    white-space: nowrap;
`;

export const CodeLinkButton = styled(Button)`
    color: ${colors.brandPrimary};
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 6px;
    width: auto;

    > span {
        white-space: nowrap;
        padding: 6px 10px;
    }
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 140px;

    animation: ${opacity} 2s ease;
`;

export const Separator = styled.div`
    width: 7px;
    height: 7px;
    background-color: ${colors.brandPrimary};
    border-radius: 50%;
`;

export const CardInfoLine = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
`;

export const CardInfoText = styled.div`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    vertical-align: middle;
    color: ${colors.darkGrey};
`;

export const CommonInfoChildren = styled.div`
    width: 100%;
`;

export const CommonInfoChildrenTitle = styled.div`
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    color: ${colors.darkGrey};
    margin-bottom: 10px;
`;
